var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnarchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.434 0a1 1 0 0 1 .857.486L20 5v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5L2.709.486A1 1 0 0 1 3.566 0h12.868ZM10 8c-.28 0-.53.11-.71.29l-3 3-.084.096A1.003 1.003 0 0 0 7.71 12.71L9 11.41v4.58l.007.116c.058.496.482.884.993.884.55 0 1-.45 1-1v-4.58l1.29 1.29.081.073c.171.139.389.227.629.227a1.003 1.003 0 0 0 .71-1.71l-3-3-.096-.084A1.002 1.002 0 0 0 10 8Zm6-6H4L2 5.002h16L16 2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchive);
export default __webpack_public_path__ + "static/media/unarchive.48f96b4059904581fe1ab0328139dd2b.svg";
export { ForwardRef as ReactComponent };